import { useState, useEffect, useCallback } from "react";
import { getAdminPaymentLedgerList } from "../Services/PaymentLedgerService";
import { toast } from "react-toastify";

export const useAdminPaymentLedger = () => {
  const [payments, setPayments] = useState({
    items: [],
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    pageNumber: 1,
    pageSize: 10,
    orderByLatest: true,
    search: "",
    startDate: null,
    endDate: null,
    status: null,
    sourceType: null,
    learnerId: null
  });

  const loadPayments = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getAdminPaymentLedgerList(filters);
      console.log("Admin payment ledger data:", data);
      setPayments(data);
    } catch (error) {
      console.error("Error loading admin payment ledger:", error);
      toast.error("Failed to load payment ledger data");
      setPayments({
        items: [],
        totalCount: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
      });
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    loadPayments();
  }, [loadPayments]);

  const handlePageChange = (pageNumber, pageSize) => {
    setFilters(prev => ({
      ...prev,
      pageNumber,
      pageSize
    }));
  };

  const handleFilterChange = (newFilters) => {
    setFilters(prev => ({
      ...prev,
      ...newFilters,
      pageNumber: 1
    }));
  };

  const handleResetFilters = () => {
    setFilters({
      pageNumber: 1,
      pageSize: 10,
      orderByLatest: true,
      search: "",
      startDate: null,
      endDate: null,
      status: null,
      sourceType: null,
      learnerId: null
    });
  };

  return {
    payments,
    loading,
    filters,
    handlePageChange,
    handleFilterChange,
    handleResetFilters,
    refresh: loadPayments
  };
};